import styles from './error-alert.module.scss';
import { useTranslation } from '../../i18n/useTranslation';
import { default as globalStyles } from '../../global-styles.module.scss';
import classNames from 'classnames';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useNavigate } from 'react-router-dom';
import ErrorIcon from '@mui/icons-material/Error';
import { errorAlertMaxWidth } from './allert.service';

interface IErrorAlertProp {
    isOpen: boolean;
    handleCloseDialog: Function;
    translateCode: string;
}

const ErrorAlert: React.FC<IErrorAlertProp> = ({ isOpen, handleCloseDialog, translateCode }) => {
    const { t } = useTranslation('translation');
    const navigate = useNavigate();

    const handleClose = () => {
        handleCloseDialog(false);
    };

    return (
        <Dialog
            open={isOpen}
            hideBackdrop={false}
            fullScreen={false}
            PaperProps={{ style: { margin: 0, maxWidth: `${errorAlertMaxWidth}px` } }}
        >
            <DialogContent>
                <div className={globalStyles.space_between_item}>
                    <div className={classNames(styles.error_alert_icon, globalStyles.float_left_item)}>
                        <ErrorIcon style={{ fontSize: '30px' }} />
                    </div>
                    <section>
                        <label>{t(translateCode)}</label>
                        <button
                            id={'error-alert-btn'}
                            className={classNames(
                                globalStyles.default_button_style,
                                styles.error_alert_btn,
                                globalStyles.mt_3
                            )}
                            onClick={() => {
                                handleClose();
                            }}
                        >
                            {t('OK')}
                        </button>
                    </section>
                </div>
            </DialogContent>
        </Dialog>
    );
};
export default ErrorAlert;
